export const SET_INPUT = 'SET_INPUT'
export const CLEAR_INPUTS = 'CLEAR_INPUTS'
export const SET_INITIAL_TOKEN_PRICE = 'SET_INITIAL_TOKEN_PRICE'
